import { useParams } from "react-router-dom";
import item1 from './usedItems/Mana Acoustics reference rack.jpg';
import item2 from './usedItems/Kudos Titan 606 Speakers.jpg';
import item3 from './usedItems/Karan Acoustics Master Collection Stereo A Power Amplifier.jpg';
import item4 from './usedItems/Karan Acoustics Phono 2.jpg';
import item5 from './usedItems/Kudos Audio C20 Speakers.jpg';
import item6 from './usedItems/DSA Amp 1.jpg';
import item7 from './usedItems/DSA Pre 1.jpg';
import item8 from './usedItems/Furutech Demag.jpg';
import React from "react";
import './responsive.css';

const usedItemsData = [
  {
    name: "Mana Acoustics Reference Rack",
    image: item1,
    condition: " Lightly Used",
    price: " $1,200",
    captions: [
         "Rarely used, still in good condition. Cash and hand carry only."
      ],
  },
  {
    name: "Kudos Titan 606 Speakers",
    image: item2,
    condition: " Lightly Used",
    price: " $9,000",
    captions: [
        "Kudos Titan 606 speakers traded in by customer,", 
        "in lightly used condition."
      ],
  },
  {
    name: "Karan Acoustics Master Collection Stereo A Power Amplifier",
    image: item3,
    condition: " Lightly Used",
    price: " $33,000",
    captions: [
        "This is a Karan Acoustics Master Collection", 
        "Stereo A Power amplifier for sale.", 
        "No dents and scratches on the item.", 
        "Price is significantly lowered as it is a showroom demo unit"
      ],
  },
  {
    name: "Karan Acoustics Phono 2",
    image: item4,
    condition: " Lightly Used",
    price: " $4,000",
    captions: [
        "Karan Acoustics Phono 2, which has a upgraded chip", 
        "by Karan Acoustics for sale.",
        "This Phono Amp supports one turntable and is a showroom demo unit.",
        "No scratches or dents."
      ],
  },
  {
    name: "Kudos Audio C20 Speakers",
    image: item5,
    condition: " Brand New",
    price: " $3,800",
    captions: [
        " A brand new in box C20 speaker in walnut colour for sale,",
         "featuring Kudos Audio iconic 2 way bass reflex."
      ],
  },
  {
    name: "DSA Amp 1",
    image: item6,
    condition: " Lightly Used",
    price: " $13,000",
    captions: [
        "Each Amp I produces 125 watts of pure Class A power and",
        "is of solid state design employing an all-JFET/MOSFET design,",
        "using DC coupled circuit topology following a source follower input", 
        "with blocking capacitors to provide a constant input impedance and ", 
        "prevent input DC offsets from damaging speakers.\n",
        "Each unit has a separate power transformer, power supply and",
        "voltage regulator for the amplifier, driver, and output stages.\n" ,
        "With internally mounted, fan cooled, power heat sinks,",
        "the small-footprint chassis: 17” (W) x 11”(D) x 18” (H) makes it easy to fit in any audio environment.", 
      ],
  },
  {
    name: "DSA Pre 1",
    image: item7,
    condition: " Like Used",
    price: " $11,000",
    captions: [
        "DSA Pre 1 pre amplifier for sale.", 
        "No scratches or dents, comes with original remote."
      ],
  },
  {
    name: "Furutech Demag",
    image: item8,
    condition: " Lightly Used",
    price: " $2,750",
    captions: [
        "The new and improved Furutech DeMagα completely", 
        "demagnetizes LPs and optical disc media such as",
        "CD, CD-R, DVD, MD, Game CD, Photo CD, SACD, and DVD Audio",
        "with 20% increased demagnetization power than the original deMag.\n", 
        "The new stylish DeMagα also features touch panel technology", 
        "for ease of use."
      ],
  },

];

// export default function UsedItemDetail() {
//   const { itemName } = useParams(); // get itemName from URL
//   const item = usedItemsData.find(
//     (i) => i.name === decodeURIComponent(itemName)
//   );

//   if (!item) return <div>Item not found</div>;

//   return (
//     <div className="used-item-detail">
//       <h1>{item.name}</h1>
//       <img src={item.image} alt={item.name} />
//       <p><strong>Condition:</strong> {item.condition}</p>
//       <p><strong>Price:</strong> {item.price}</p>
//       <p><strong>Description:</strong></p>
//         <ul>
//             {item.captions.map((line, index) => (
//             <li key={index}>{line}</li>
//             ))}
//         </ul>
//     </div>
//   );
// }

export default function UsedItemDetail() {
  const { itemName } = useParams(); // get itemName from URL
  const item = usedItemsData.find(
    (i) => i.name === decodeURIComponent(itemName)
  );

  if (!item) return <div>Item not found</div>;

  // <-- REPLACE YOUR CURRENT RETURN STATEMENT HERE -->
  return (
    <div className="used-item-detail">
      <h1>{item.name}</h1>
      <div className="item-content">
        <img src={item.image} alt={item.name} className="item-image" />

        <div className="item-details">
        <div className="detail-row">
        <strong className="label">Condition:</strong>
        <span className="value">{item.condition}</span>
        </div>

        <div className="detail-row">
        <strong className="label">Price:</strong>
        <span className="value">{item.price}</span>
        </div>

        <div className="detail-row description">
        <strong className="label">Description:</strong>
        <span className="value">{item.captions.join("\n")}</span>
        </div>
        </div>
      </div>
    </div>
  );
}